/* MMS rental dates (added 2026-10-15; OPTIONAL; weekdays only; holidays; booked ranges). Works with snippets/mms-rental-dates.liquid. Holidays: assets/mms-holidays.js (shared).
   - Closed: Saturdays, Sundays and major US holidays (computed for any year): New Year's Day, Memorial Day,
     Independence Day, Labor Day, Thanksgiving, Day after Thanksgiving, Christmas Eve, Christmas Day; fixed-date holidays on a Saturday are observed the
     Friday before, on a Sunday the Monday after (both the holiday and the observed day are closed).
   - Booked days come from the "Rental bookings" ranges (custom.rental_bookings -> data-ranges, every day start..end inclusive). They are disabled in
     the calendar, typed booked days are cleared with a note, and a note shows if the chosen range spans one.
   - Dates are optional and NEVER block add to cart.
   - Text fields use MM/DD/YYYY; the calendar button opens a small calendar where Saturdays, Sundays and past
     days are disabled (and, for the stop date, days before the start date).
   - Typed dates that fall on a Saturday/Sunday are cleared with a note ("We're closed weekends...") so they are
     never saved as a line item property.
   - On add to cart, values are normalized to MM/DD/YYYY and empty fields are left out
     (temporarily disabled so no blank line item properties are added).
   - Other gentle notes: stop before start, start in the past, unreadable date. */
(function () {
  if (window.__mmsRentalDates) return;
  window.__mmsRentalDates = true;
  var WEEKEND_MSG = 'We\u2019re closed weekends, please pick a weekday.';
  var BOOKED_MSG = 'That date is already booked, please pick another.';
  var HOLIDAY_MSG = 'We\u2019re closed that day (holiday), please pick another.';
  /* holiday list lives in the shared assets/mms-holidays.js (also used by the zip delivery estimate) */
  function holidayName(ymd) { return window.MMSHolidays ? window.MMSHolidays.shopHolidayName(ymd) : ''; }
  window.__mmsHolidayName = holidayName;
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }
  function ymdOf(dt) { return dt.getFullYear() + '-' + pad(dt.getMonth() + 1) + '-' + pad(dt.getDate()); }
  /* 5:00 PM Eastern same-day cutoff (added 2026-10-30 per Damon): today is computed in America/New_York regardless of the visitor's timezone; from 17:00 ET on, today is crossed off like a weekend. window.__mmsNow (a Date) can be set in the console to test. */
  var CUTOFF_HOUR = 17;
  function etParts() {
    var now = window.__mmsNow instanceof Date ? window.__mmsNow : new Date(), o = {};
    try { new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(now).forEach(function (p) { o[p.type] = p.value; }); }
    catch (x) { return { ymd: ymdOf(now), hour: now.getHours() }; }
    return { ymd: o.year + '-' + o.month + '-' + o.day, hour: +o.hour % 24 };
  }
  function todayYmd() { return etParts().ymd; }
  function pastCutoff() { return etParts().hour >= CUTOFF_HOUR; }
  /* earliest selectable day: today, or tomorrow once it is 5 PM ET (weekends/holidays/booked still apply on top) */
  function earliestYmd() { var p = etParts(); if (p.hour < CUTOFF_HOUR) return p.ymd; var d = new Date(+p.ymd.slice(0, 4), +p.ymd.slice(5, 7) - 1, +p.ymd.slice(8, 10) + 1); return ymdOf(d); }
  window.__mmsEarliestYmd = earliestYmd;
  var CUTOFF_MSG = 'Same-day rentals must be booked before 5:00 PM Eastern, please pick another day.';
  /* returns {us:'MM/DD/YYYY', ymd:'YYYY-MM-DD', weekend:bool} or null */
  function parse(v) {
    v = (v || '').trim(); if (!v) return null;
    var m, y, mo, d;
    if ((m = v.match(/^(\d{4})[-\/.](\d{1,2})[-\/.](\d{1,2})$/))) { y = +m[1]; mo = +m[2]; d = +m[3]; }
    else if ((m = v.match(/^(\d{1,2})[-\/. ](\d{1,2})[-\/. ](\d{2}|\d{4})$/))) { mo = +m[1]; d = +m[2]; y = +m[3]; if (y < 100) y += 2000; }
    else if ((m = v.match(/^(\d{2})(\d{2})(\d{4})$/))) { mo = +m[1]; d = +m[2]; y = +m[3]; }
    else return null;
    var dt = new Date(y, mo - 1, d);
    if (dt.getFullYear() !== y || dt.getMonth() !== mo - 1 || dt.getDate() !== d) return null;
    var wd = dt.getDay();
    return { us: pad(mo) + '/' + pad(d) + '/' + y, ymd: y + '-' + pad(mo) + '-' + pad(d), weekend: wd === 0 || wd === 6 };
  }
  function autoSlash(el) {
    var v = el.value;
    if (!/^[\d\/]*$/.test(v) || v.indexOf('/') !== -1) return;
    var s = v.slice(0, 8), out = s;
    if (s.length > 4) out = s.slice(0, 2) + '/' + s.slice(2, 4) + '/' + s.slice(4);
    else if (s.length > 2) out = s.slice(0, 2) + '/' + s.slice(2);
    if (out !== v) el.value = out;
  }
  function addCss() {
    if (document.getElementById('mms-rental-cal-css')) return;
    var st = document.createElement('style'); st.id = 'mms-rental-cal-css';
    st.textContent =
      '.mms-cal{position:absolute;top:calc(100% + 4px);right:0;z-index:50;width:28rem;padding:1rem;background:rgb(var(--color-background,255,255,255));color:rgb(var(--color-foreground,0,0,0));border:1px solid rgba(var(--color-foreground,0,0,0),.25);border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.18);font-size:1.4rem}' +
      '.mms-cal__head{display:flex;align-items:center;justify-content:space-between;margin-bottom:.6rem;font-weight:600}' +
      '.mms-cal__nav{border:0;background:none;font-size:2rem;line-height:1;padding:.2rem .8rem;cursor:pointer;color:inherit}' +
      '.mms-cal__nav:disabled{opacity:.25;cursor:default}' +
      '.mms-cal__grid{display:grid;grid-template-columns:repeat(7,1fr);gap:2px;text-align:center}' +
      '.mms-cal__dow{font-size:1.2rem;opacity:.7;padding:.3rem 0}' +
      '.mms-cal__day{border:0;border-radius:4px;background:none;padding:.6rem 0;font:inherit;cursor:pointer;color:inherit}' +
      '.mms-cal__day:hover:not(:disabled){background:rgba(var(--color-foreground,0,0,0),.1)}' +
      '.mms-cal__day:disabled{opacity:.28;cursor:not-allowed;text-decoration:line-through}' +
      '.mms-cal__day--sel{background:rgb(var(--color-foreground,0,0,0))!important;color:rgb(var(--color-background,255,255,255))}' +
      '.mms-cal__day[data-booked-day]{color:#b00020;opacity:.45}' +
      '.mms-cal__foot{margin-top:.6rem;font-size:1.2rem;opacity:.75;text-align:center}';
    document.head.appendChild(st);
  }
  var openCal = null;
  function closeCal() { if (openCal) { openCal.remove(); openCal = null; } }
  document.addEventListener('click', function (ev) {
    if (openCal && !openCal.contains(ev.target) && !ev.target.closest('[data-rental-cal]')) closeCal();
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeCal(); });

  function showCal(wrap, txt, minYmd, onPick, booked) {
    booked = booked || {};
    closeCal(); addCss();
    var cur = parse(txt.value), base = cur ? cur.ymd : minYmd;
    var view = new Date(+base.slice(0, 4), +base.slice(5, 7) - 1, 1);
    var cal = document.createElement('div'); cal.className = 'mms-cal'; cal.setAttribute('role', 'dialog'); cal.setAttribute('aria-label', 'Choose a date');
    function render() {
      var y = view.getFullYear(), m = view.getMonth();
      var minMonth = minYmd.slice(0, 7), thisMonth = y + '-' + pad(m + 1);
      var h = '<div class="mms-cal__head"><button type="button" class="mms-cal__nav" data-nav="-1" aria-label="Previous month"' + (thisMonth <= minMonth ? ' disabled' : '') + '>&lsaquo;</button><span>' + MONTHS[m] + ' ' + y + '</span><button type="button" class="mms-cal__nav" data-nav="1" aria-label="Next month">&rsaquo;</button></div><div class="mms-cal__grid">';
      ['Su','Mo','Tu','We','Th','Fr','Sa'].forEach(function (d) { h += '<span class="mms-cal__dow">' + d + '</span>'; });
      var first = new Date(y, m, 1).getDay(), days = new Date(y, m + 1, 0).getDate();
      for (var i = 0; i < first; i++) h += '<span></span>';
      for (var d = 1; d <= days; d++) {
        var dt = new Date(y, m, d), ymd = ymdOf(dt), wd = dt.getDay();
        var isBooked = !!booked[ymd], hol = holidayName(ymd);
        var cut = ymd === todayYmd() && pastCutoff();
        var dis = wd === 0 || wd === 6 || ymd < minYmd || cut || isBooked || !!hol;
        h += '<button type="button" class="mms-cal__day' + (cur && cur.ymd === ymd ? ' mms-cal__day--sel' : '') + '" data-ymd="' + ymd + '"' + (dis ? ' disabled aria-disabled="true"' : '') + ' aria-label="' + MONTHS[m] + ' ' + d + ', ' + y + (wd === 0 || wd === 6 ? ' (closed weekends)' : '') + (hol ? ' (closed, ' + hol + ')' : '') + (isBooked ? ' (already booked)' : '') + (cut ? ' (past 5 PM ET cutoff)' : '') + '"' + (isBooked ? ' data-booked-day' : '') + (hol ? ' data-holiday title="Closed: ' + hol + '"' : '') + '>' + d + '</button>';
      }
      h += '</div><div class="mms-cal__foot">Closed weekends &amp; major holidays \u00b7 same-day cutoff 5 PM ET' + (Object.keys(booked).length ? ' \u00b7 red crossed-off days are booked' : '') + '</div>';
      cal.innerHTML = h;
    }
    cal.addEventListener('click', function (ev) {
      ev.stopPropagation();
      var nav = ev.target.closest('[data-nav]');
      if (nav && !nav.disabled) { view.setMonth(view.getMonth() + +nav.getAttribute('data-nav')); render(); return; }
      var day = ev.target.closest('[data-ymd]');
      if (day && !day.disabled) { var p = parse(day.getAttribute('data-ymd')); txt.value = p.us; closeCal(); onPick(); try { txt.focus(); } catch (x) {} }
    });
    render(); wrap.appendChild(cal); openCal = cal;
    var b = cal.querySelector('.mms-cal__day--sel') || cal.querySelector('.mms-cal__day:not(:disabled)');
    if (b) { try { b.focus({ preventScroll: true }); } catch (x) {} }
  }

  function setup(box) {
    if (box.__mmsInit) return; box.__mmsInit = true;
    var s = box.querySelector('[data-rental-start]'), e = box.querySelector('[data-rental-stop]');
    var note = box.querySelector('.mms-rental-dates__note');
    var booked = {};
    /* booking ranges from "Rental bookings" metaobjects: "YYYY-MM-DD~YYYY-MM-DD,..." -> every day start..end (inclusive) */
    (box.getAttribute('data-ranges') || '').split(',').forEach(function (r) {
      var p = r.trim().split('~'); if (p.length !== 2) return;
      var a = parse(p[0]), b = parse(p[1]); if (!a || !b) return;
      if (b.ymd < a.ymd) { var t = a; a = b; b = t; }
      var d = new Date(+a.ymd.slice(0, 4), +a.ymd.slice(5, 7) - 1, +a.ymd.slice(8, 10));
      for (var i = 0; i < 731; i++) { var k = ymdOf(d); if (k > b.ymd) break; booked[k] = true; d.setDate(d.getDate() + 1); }
    });
    var clearedMsg = '';
    function spanBooked(a, b) {
      var hits = Object.keys(booked).filter(function (k) { return k > a && k < b; }).sort();
      return hits.length ? hits[0] : null;
    }
    function notes() {
      var ps = parse(s.value), pe = parse(e.value), msgs = [];
      if (clearedMsg) msgs.push(clearedMsg);
      if (s.value.trim() && !ps) msgs.push('Please enter the Rental Start Date as MM/DD/YYYY.');
      if (e.value.trim() && !pe) msgs.push('Please enter the Rental Stop Date as MM/DD/YYYY.');
      if (ps && ps.ymd < todayYmd()) msgs.push('The Rental Start Date looks like it is in the past.');
      if (ps && pe && pe.ymd < ps.ymd) msgs.push('The Rental Stop Date is before the Rental Start Date.');
      if (ps && pe && pe.ymd > ps.ymd) { var hit = spanBooked(ps.ymd, pe.ymd); if (hit) msgs.push('Heads up: your rental dates include a day that is already booked (' + parse(hit).us + '). Please pick different dates or call us.'); }
      note.textContent = msgs.join(' '); note.hidden = !msgs.length;
    }
    /* normalize to MM/DD/YYYY; clear weekend/holiday/booked dates (never saved). Returns the note for a cleared date, or ''. */
    function normalize(el) {
      var p = parse(el.value);
      if (p && p.weekend) { el.value = ''; return WEEKEND_MSG; }
      if (p && holidayName(p.ymd)) { el.value = ''; return HOLIDAY_MSG; }
      if (p && booked[p.ymd]) { el.value = ''; return BOOKED_MSG; }
      if (p && p.ymd === todayYmd() && pastCutoff()) { el.value = ''; return CUTOFF_MSG; }
      if (p) el.value = p.us;
      return '';
    }
    function onCommit(el) {
      var m = normalize(el);
      if (m) clearedMsg = m;
      else if (el.value.trim()) clearedMsg = '';
      notes();
    }
    [s, e].forEach(function (el) {
      el.addEventListener('input', function () { autoSlash(el); });
      el.addEventListener('blur', function () { onCommit(el); });
      el.addEventListener('change', function () { onCommit(el); });
    });
    box.querySelectorAll('[data-rental-cal]').forEach(function (btn) {
      var key = btn.getAttribute('data-rental-cal');
      var txt = key === 'start' ? s : e;
      var wrap = btn.closest('.mms-rental-dates__wrap');
      btn.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        if (openCal && openCal.parentNode === wrap) { closeCal(); return; }
        var t = earliestYmd(), ps = parse(s.value);
        var min = key === 'stop' && ps && !ps.weekend && ps.ymd > t ? ps.ymd : t;
        showCal(wrap, txt, min, function () { clearedMsg = ''; notes(); }, booked);
      });
    });
    var holder = box.closest('product-form') || box.closest('form');
    if (holder) {
      /* capture phase: runs before Dawn's product-form builds FormData; never cancels the submit */
      holder.addEventListener('submit', function () {
        closeCal();
        [s, e].forEach(function (el) {
          var m = normalize(el); if (m) { clearedMsg = m; notes(); }
          if (!el.value.trim()) { el.value = ''; el.disabled = true; }
        });
        setTimeout(function () { s.disabled = false; e.disabled = false; }, 0);
      }, true);
    }
  }
  function init() { document.querySelectorAll('[data-mms-rental-dates]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
